export default {
  termsDescription: {
    id: 'insurances_us_terms_description',
    defaultMessage:
      'I understand that my {insuranceOfferName, html} will renew automatically {duration, html}, and I agree that my payment method will be charged {duration, html} until I cancel. I can cancel anytime {faqLink, html}',
  },
  faqLinkLabel: {
    id: 'insurances_options_biennial_faq_link_content',
    defaultMessage: 'through my account',
  },
  faqLinkValue: {
    id: 'insurances_options_biennial_faq_link_value',
    defaultMessage:
      'https://help.backmarket.com/hc/en-us/articles/4404019304594-Can-I-cancel-my-Protection-Plan',
  },
  termsLinkContent: {
    id: 'insurances_options_biennial_terms_link_content',
    defaultMessage: 'Terms and Conditions',
  },
  monthlyDuration: {
    id: 'insurances_us_monthly_duration',
    defaultMessage: 'each month',
  },
  annuallyDuration: {
    id: 'insurances_us_annually_duration',
    defaultMessage: 'each year',
  },
  bienniallyDuration: {
    id: 'insurances_us_biennially_duration',
    defaultMessage: 'every 2 years',
  },
}
